import script from "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=style&index=0&id=26dacc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26dacc32"]])

export default __exports__